module.exports = __webpack_public_path__ + "img/qr-icon.07a838b6.svg";